// components/invitePartner/InviteAccepted.jsx
import ButtonCustom from '../atoms/button/ButtonCustom'
import styles from './invite.module.scss'

export const InviteAcceptedView = ({ openModal }) => {
	return (
		<div className={styles.cardContainer}>
			<h2 className={styles.subTitle}>Partners invited!</h2>
			<p>Both partners have already been invited to this wedding.</p>
			<ButtonCustom variant="destructive" onClick={() => openModal('removePartner')} className={styles.removeBtn}>Remove Partner</ButtonCustom>
		</div>
	)
}
